var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-17d19b28-2347-4c65-bd0c-ffb213f6d69c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-64a30ca4-654c-41b6-8dc8-6c7209fd6e4f {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-64a30ca4-654c-41b6-8dc8-6c7209fd6e4f",
    d: "M12.66,22.97c-.27,0-.55-.11-.75-.33-.37-.41-.33-1.04.08-1.41l5.84-5.23-5.84-5.23c-.41-.37-.45-1-.08-1.41.37-.41,1-.45,1.41-.08l6.68,5.97c.21.19.33.46.33.75s-.12.56-.33.75l-6.68,5.97c-.19.17-.43.25-.67.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.43fcd6a8d13798ff50aa183f9abc0efd.svg";
export { ForwardRef as ReactComponent };